import { useQuery } from '@tanstack/react-query'
import { fetchBMData } from './fetchBMData'
import { BlockedData } from './BMDataTypes'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useBMStore } from '../../stores/useBMStore'

export const useBlockedQuery = (offset: number) => {
  const { networkId: networkIdEnc } = useUserStore()
  const { fromDate, toDate } = useBMStore((state) => state.dateRange)
  const searchQuery = useBMStore((state) => state.searchQuery)
  const advancedFilters = useBMStore((state) => state.advancedFilters)

  const queryEnabled = !!networkIdEnc && !!fromDate && !!toDate

  return useQuery<BlockedData>({
    queryKey: ['blocked', networkIdEnc, fromDate, toDate, offset, searchQuery, advancedFilters],
    enabled: queryEnabled,

    queryFn: () => {
      const params: Record<string, any> = {
        limit: 300,
        offset,
        'from-date': fromDate,
        'to-date': toDate,
        last3months: false,
        search: searchQuery,
        group: '',
      }

      if (advancedFilters?.threatGroups?.length === 1) {
        params['group'] = advancedFilters.threatGroups[0]
      }

      if (advancedFilters?.countries?.length) {
        params['countries'] = advancedFilters.countries
      }

      if (advancedFilters?.threatTypes?.length) {
        params['threatTypes'] = advancedFilters.threatTypes
      }

      if (advancedFilters?.domains?.length) {
        params['domains'] = advancedFilters.domains
      }

      return fetchBMData<BlockedData>('blocked', networkIdEnc, { params })
    },
  })
}
